import { EventEmitter } from '@angular/core';

export abstract class DatePickerInterface {

  /**
   * Unique id set for each datepicker
   */
  uniqueId: string;
  /**
   * Date picker input focus event emitter
   */
  inputFocusEventEmitter: EventEmitter<boolean> = new EventEmitter();
  /**
   * Focuses date picker input
   */
  focusInput(): void {
    this.inputFocusEventEmitter.emit(true);
  }
}
